import React from 'react'
import PropTypes from 'prop-types'

import ChevronUp from '../../icons/ChevronUp'
import { isDesktop } from '../../app/ui'
import withIframeStyle from '../../containers/WithIframeStyle'
import iframeObserver from '../../utils/iframe-observer'
import { getRestaurantMenuNavStyle } from '../../utils/iframe-style-helper'
import { IFRAME_CONFIG } from '../../config'
import { debounce } from '../../app/lodash-cut'

class OtoSidebar extends React.PureComponent {
  state = { hasScroll: false, style: {} }
  retried = false
  titleRef = React.createRef()
  contentRef = React.createRef()
  
  componentDidMount() {
    this.debouncedDimensions =  debounce(this.updateDimensions, 300)
    this.setHasScroll()
    $('#sidebarContent').on('shown.bs.collapse', this.setHasScroll)
    window.addEventListener('resize', this.debouncedDimensions)
  }
  updateDimensions = () => {
    this.setState({ style: { maxHeight: window.innerHeight } })
  }
  componentWillUnmount() {
    window.removeEventListener('resize', this.debouncedDimensions)
  }

  getHeights = () => {
    if (iframeObserver.hasParentIframe()) {
      return {
        headerHeight: IFRAME_CONFIG.fixedHeaderHeight,
        windowHeight: iframeObserver.lastPageInfo.documentHeight,
      }
    }
    const navbar = document.querySelector('.navbar')
    const navbarHeight = navbar ? navbar.offsetHeight : 0
    return {
      headerHeight: navbarHeight,
      windowHeight: window.innerHeight,
    }
  }

  setHasScroll = () => {
    let hasScroll = false
    if (this.contentRef.current && this.contentRef.current.offsetHeight) {
      const sidebarContentHeight = this.contentRef.current.offsetHeight
      const titleHeight = this.titleRef.current.offsetHeight || 0
      const amountToExtract = isDesktop()
        ? this.props.extractOnDesktop
        : this.props.extractOnMobile
      const { headerHeight, windowHeight } = this.getHeights()
      hasScroll =
        sidebarContentHeight >
        windowHeight - headerHeight - titleHeight - amountToExtract
      const maxHeight = hasScroll
        ? `calc(${windowHeight}px - ${headerHeight}px - ${amountToExtract}px)`
        : 'auto'
      if (
        this.state.hasScroll !== hasScroll ||
        this.state.style.maxHeight !== maxHeight
      ) {
        this.setState({
          hasScroll,
          style: {
            maxHeight,
            overflowY: hasScroll ? 'scroll' : 'visible',
          },
        })
      }
    } else {
      if (!this.retried) {
        this.retried = true
        setTimeout(this.setHasScroll, 1000)
      }
    }
  }

  componentDidUpdate() {
    this.setHasScroll()
  }

  render() {
    return (
      <aside
        className={`sidebar ${this.props.className}`}
        style={{
          ...this.state.style,
          ...this.props.style,
          ...this.props.iframeStyle,
        }}
      >
        <h4
          className="sidebar__title collapsed"
          role="button"
          data-toggle="collapse"
          data-target="#sidebarContent"
          aria-expanded="true"
          aria-controls="sidebarContent"
          ref={this.titleRef}
        >
          {this.props.title}
          <ChevronUp />
        </h4>
        <div
          className="collapse sidebar__content"
          id="sidebarContent"
          ref={this.contentRef}
        >
          {this.props.children}
        </div>
      </aside>
    )
  }
}

export default withIframeStyle(OtoSidebar, getRestaurantMenuNavStyle)

OtoSidebar.propTypes = {
  className: PropTypes.string,
  style: PropTypes.object,
  title: PropTypes.string.isRequired,
  extractOnDesktop: PropTypes.number,
  extractOnMobile: PropTypes.number,
}

OtoSidebar.defaultProps = {
  className: '',
  style: {},
  iframeStyle: {},
  extractOnDesktop: 100,
  extractOnMobile: 50,
}

OtoSidebar.displayName = 'OtoSidebar'
